module.exports = { 
    getVstopSSvetovanjemStrankaPrisotnaclen545Form () {
        return {
            podpisZavarovalec: {
                name: 'podpisZavarovalec',
                type: 'xs:base64Binary',
                formType: 'signature',
                required: true,
                value: undefined,
            },
            podpisSvetovalec: {
                name: 'podpisSvetovalec',
                type: 'xs:base64Binary',
                formType: 'signature',
                required: true,
                value: undefined,
            },
        }
    }
};